(function ($, Shopify) {
    ("use strict");

    // Cart shipping calc date picker attributes
    const processDays = 2; // Minimum date (today + processDays) to display in date picker
    const dateMax = 30; // Maximum date (today + dateMax) to display in date picker
    const shipDays = [1, 2, 3, 5, 6]; // 0 = sunday. Days of week shipping is offered

    // Cart shipping calc selectors
    const cEl = {
        filled: "form-field-filled",
        highlight: "ml-form-field-input--highlight",
        none: "ml-hidden",
        hidden: "ml-visibility-hidden",
        zip: "#address_zip",
        zipForm: "#address_zip",
        zipEmpty: "label[for='address_zip'] .form-field-title--empty",
        method: "#ml_ship_method",
        methodForm: ".ml-form-field--cart-method",
        methodEmpty: "label[for='ml_ship_method'] .form-field-title--empty",
        date: "#ml_ship_date",
        dateForm: ".ml-form-field--cart-date",
        dateEmpty: "label[for='ml_ship_date'] .form-field-title--empty",
        submit: "button[data-cartshipping-submit]",
    };

    // Initialize variables & get stored zip code
    let shipMethod = "";
    let shipDate = "";
    let shipZip = sessionStorage.getItem("shipping_zipcode") || "";
    let pageLoaded = false;

    // Delays populating zip code until page is fully loaded
    $(window).on("load", function () {
        setTimeout(function () {
            setZipInput(shipZip);
            zipUpdate("Page load triggered zipUpdate()");
            pageLoaded = true;
        }, 1500);
    });

    function setZipInput(zipcode) {
        if (zipcode.length != 0 && isValidZipCode(zipcode)) {
            $(cEl.zip).trigger("focus").val(zipcode).trigger("blur");
        }
    }

    // Add smooth scrolling
    $("#shipping-calculator").on("click", "button", function (e) {
        theOffset = $(this).offset();
        $("html, body").animate(
            {
                scrollTop: theOffset.top - 120,
            },
            1200,
            function () {
                //window.location.hash = '#shipping-calculator';
            }
        );
    });

    // Click "Calculate Shipping" button automatically when zip code input is populated
    $(cEl.zip).change(function () {
        if (pageLoaded) {
            zipUpdate("Zip update triggered zipUpdate()");
        }
    });

    // Trigger change event on "enter" key press, then remove focus
    $(cEl.zip).keydown(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            $(this).trigger("change").trigger("blur");
        }
    });

    function zipUpdate(logMessage) {
        shipZip = $(cEl.zip).val();
        $(cEl.zip).attr("value", shipZip);
        console.log("Shipping zip changed to: " + shipZip);

        if (!shipZip) {
            // Add "Enter" form label when field is not populated
            $(cEl.zipEmpty).removeClass(cEl.none);
            $(cEl.zipForm).addClass(cEl.highlight);
            $(cEl.submit).addClass(cEl.highlight);
            $(cEl.methodForm).addClass(cEl.hidden);
            $(cEl.dateForm).addClass(cEl.hidden);
        } else {
            // Remove "Enter" from label when field is populated
            $(cEl.zipEmpty).addClass(cEl.none);
            $(cEl.zipForm).removeClass(cEl.highlight);
            $(cEl.submit).removeClass(cEl.highlight);
            $(cEl.methodForm).removeClass(cEl.hidden);
            $(cEl.dateForm).addClass(cEl.hidden);

            if (isValidZipCode(shipZip)) {
                storeZipcode(shipZip);
            }

            // Reset inputs, update line item properties when new zip entered
            resetShipDate();
            resetShipMethod();

            $.when(setShippingOption()).done(function () {
                $(cEl.submit).trigger("click");
            });

            console.log('Zip change triggered "Calculate Shipping" button click');
        }
    }

    $(cEl.method).change(function () {
        shipMethod = $(this).children("option:selected").val();
        $(cEl.method).attr("value", shipMethod);

        if (shipMethod) {
            console.log("Shipping method changed to: " + shipMethod);

            $(cEl.methodEmpty).addClass(cEl.none);
            $(cEl.method).removeClass(cEl.highlight);
            $(cEl.dateForm).removeClass(cEl.hidden);
            // Reset date when shipping method is changed
            resetShipDate();
        } else {
            $(cEl.methodEmpty).removeClass(cEl.none);
            $(cEl.method).addClass(cEl.highlight);
            $(cEl.dateForm).addClass(cEl.hidden);
        }
    });

    $(".readonly").on("keydown paste", function (e) {
        e.preventDefault();
    });

    function resetShipDate() {
        shipDate = "";
        $(cEl.date).datepicker();
        $(cEl.date).datepicker("setDate", shipDate);
        //$(cEl.date).removeClass(cEl.filled);
        $(cEl.date).attr("value", shipDate);
    }

    function resetShipMethod() {
        shipMethod = "";
        $(cEl.method).attr("value", shipMethod);
        $(cEl.method + " option:eq(0)").prop("selected", true);
        $(cEl.methodEmpty).removeClass(cEl.none);
        //$(cEl.method).removeClass(cEl.filled);
    }

    $(cEl.date).datepicker({
        onSelect: function (date) {
            console.log("Shipping date changed to: " + $(this).val());
            $(this).attr("value", date);
            $(this).addClass(cEl.filled);
            shipDate = date;

            if (shipDate) {
                $(cEl.date).removeClass(cEl.highlight);
                $(cEl.dateEmpty).addClass(cEl.none);
            } else {
                $(cEl.date).addClass(cEl.highlight);
                $(cEl.dateEmpty).removeClass(cEl.none);
            }

            // Update line item property values
            setShippingOption("Date select triggered setShippingOption()");
            //setCartAttributes("Date select triggered setCartAttributes()");
        },
        selectWeek: true,
        inline: true,
        startDate: "01/01/2000",
        firstDay: 1,
        minDate: processDays,
        maxDate: dateMax,
        beforeShowDay: function (date) {
            return [shipDays.indexOf(date.getDay()) > -1];
        },
    });

    function setShippingOption(logMessage = null) {
        if (logMessage) {
            console.log(logMessage);
        }

        let shipping_option = {
            "_ml-ship-method": shipMethod,
            "_ml-ship-date": shipDate,
        };
        let line_items_length = 0;
        $.getJSON("/cart.js").then(function (response) {
            line_items_length = response.items.length;

            let chain = $.when();

            for (let i = 1; i <= line_items_length; i++) {
                chain = chain.then(function () {
                    return $.ajax({
                        type: "POST",
                        url: "/cart/change.js",
                        data: {
                            line: i,
                            properties: shipping_option,
                        },
                        success: function (d) {
                            console.log(d);
                        },
                        dataType: "json",
                    });
                });
            }

            chain.then();
        });
    }

    function isValidZipCode(zipcode) {
        return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipcode);
    }

    function storeZipcode(zipcode) {
        if (isValidZipCode(zipcode)) {
            sessionStorage.setItem("shipping_zipcode", zipcode);
        }
    }
})(jQuery, Shopify);
